import React, { Fragment } from 'react';
import pt from 'prop-types';
import { FadeInUp } from 'components/transitions';
import StoreIcon from 'components/store/icon';
import auth from 'services/auth';
import Logo from 'partners/components/logo';
import './login.scss';

/**
 * Accepting a store's partner invite, once logged in: pick the partner
 * dashboard to connect the store to.
 */
export default class AcceptStorePage extends React.PureComponent {
  static propTypes = {
    storeInvite: pt.shape({
      client_name: pt.string,
      email: pt.string,
      error: pt.shape({ message: pt.string }),
    }),
    // Partner dashboards of the logged in user
    storeInvitePartners: pt.arrayOf(
      pt.shape({ id: pt.string, name: pt.string, icon: pt.object }),
    ),
    onSelectAcceptPartner: pt.func.isRequired,
  };

  onClickPartner = (event) => {
    event.preventDefault();
    this.props.onSelectAcceptPartner(event.currentTarget.dataset.id);
  };

  renderError() {
    const { storeInvite } = this.props;

    return (
      <Fragment>
        <div className="login-subheading">
          <span className="login-subheading-bold">
            {storeInvite.error.message}
          </span>
          <br />
          Ask the store to send you a new invitation.
        </div>
        <div className="login-actions">
          <a
            href="/login"
            className="button button-large button-default accept-store-action"
          >
            Go to login
          </a>
        </div>
      </Fragment>
    );
  }

  renderNoPartners() {
    return (
      <Fragment>
        <div className="login-subheading">
          <span className="login-subheading-bold">
            You don&apos;t have a partner dashboard yet
          </span>
          <br />
          Create a partner dashboard first, then follow the invitation link
          again to connect the store.
        </div>
        <div className="login-actions">
          <a
            href={auth.getPartnerSignupUrl()}
            className="button button-large button-default accept-store-action"
          >
            Create a partner dashboard
          </a>
        </div>
      </Fragment>
    );
  }

  renderPartners() {
    const { storeInvite, storeInvitePartners } = this.props;

    return (
      <Fragment>
        <div className="login-subheading">
          Choose the partner dashboard to connect{' '}
          <span className="login-subheading-bold capitalized">
            {storeInvite.client_name}
          </span>{' '}
          to.
        </div>
        <div className="accept-store-partners">
          {storeInvitePartners.map((partner) => (
            <button
              key={partner.id}
              type="button"
              className="accept-store-partner"
              data-id={partner.id}
              onClick={this.onClickPartner}
            >
              <StoreIcon
                store={{ name: partner.name, icon: partner.icon }}
                size={32}
              />
              <span className="accept-store-partner-name">{partner.name}</span>
            </button>
          ))}
        </div>
      </Fragment>
    );
  }

  renderStep() {
    const { storeInvite, storeInvitePartners } = this.props;

    if (storeInvite.error) {
      return this.renderError();
    }

    if (!storeInvitePartners?.length) {
      return this.renderNoPartners();
    }

    return this.renderPartners();
  }

  render() {
    return (
      <div className="login-form login-form-join">
        <FadeInUp>
          <div>
            <div className="logo-container">
              <Logo />
            </div>
            {this.renderStep()}
          </div>
        </FadeInUp>
      </div>
    );
  }
}
